import { FC } from 'react';
import { JSXMapSerializer, PrismicRichText } from '@prismicio/react';
import { Content, GroupField } from '@prismicio/client';
import { Simplify } from '../../../../../../../prismicio-types';

import styles from './List.module.scss';

const titleComponents: JSXMapSerializer = {
  paragraph: ({ children }) => <p className={styles.title}>{children}</p>,
};

const descriptionComponents = (
  variant: 'primary' | 'secondary' | 'primary-nested'
): JSXMapSerializer => ({
  paragraph: ({ children }) => <p className={styles.description}>{children}</p>,
  oList: ({ children }) => (
    <ol className={`${styles.numberedList} ${styles[variant]}`}>{children}</ol>
  ),
  list: ({ children }) => (
    <ul className={`${styles.bulletedList} ${styles[variant]}`}>{children}</ul>
  ),
});

type Props = {
  list: GroupField<Simplify<Content.ModalSlicePrivacyPolicyPrimaryList1Item>>;
};

export const List: FC<Props> = ({ list }) => {
  return (
    <ul className={styles.list}>
      {list.map((item, index) => (
        <li key={index} className={styles.item}>
          <PrismicRichText field={item.title} components={titleComponents} />
          <div
            className={`${styles.descriptionWrapper} ${styles[item.list_variant]}`}
          >
            <PrismicRichText
              field={item.description}
              components={descriptionComponents(item.list_variant)}
            />
          </div>
        </li>
      ))}
    </ul>
  );
};
